module.exports = __webpack_public_path__ + "static/media/image_27.7edd40c6.png";